import { render, staticRenderFns } from "./orderStatusPopup.vue?vue&type=template&id=fc311d52&scoped=true"
import script from "./orderStatusPopup.vue?vue&type=script&lang=js"
export * from "./orderStatusPopup.vue?vue&type=script&lang=js"
import style0 from "./orderStatusPopup.vue?vue&type=style&index=0&id=fc311d52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc311d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc311d52')) {
      api.createRecord('fc311d52', component.options)
    } else {
      api.reload('fc311d52', component.options)
    }
    module.hot.accept("./orderStatusPopup.vue?vue&type=template&id=fc311d52&scoped=true", function () {
      api.rerender('fc311d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/supplierOrder/orderStatusPopup.vue"
export default component.exports